
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Capa_1","data-name":"Capa 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M60.61 26.69l9.01 9.01H85l-6.19-9.01h-18.2z"}}),_c('path',{staticClass:"cls-2",attrs:{"transform":"rotate(-90 49.41 53)","d":"M23.1 24.78h52.62v56.44H23.1z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M21.19 26.69h18.2v52.62h-18.2z"}}),_c('path',{staticClass:"cls-3",attrs:{"transform":"rotate(-90 56.88 32.34)","d":"M54.93 14.85h3.91v34.99h-3.91z"}}),_c('path',{staticClass:"cls-4",attrs:{"transform":"rotate(-90 31.92 32.34)","d":"M29.96 24.87h3.91v14.94h-3.91z"}}),_c('path',{staticClass:"cls-3",attrs:{"transform":"rotate(-90 56.88 73.92)","d":"M54.93 56.43h3.91v34.99h-3.91z"}}),_c('path',{staticClass:"cls-4",attrs:{"transform":"rotate(-90 31.92 73.92)","d":"M29.96 66.45h3.91v14.94h-3.91z"}}),_c('path',{staticClass:"cls-5",attrs:{"d":"M55.07 63.27l3.47-5.9-3.47-1.97v7.87zM63.15 50.47l-7.78 4.41.04.02 7.74 4.38 7.78-4.4-7.78-4.41z"}}),_c('path',{staticClass:"cls-5",attrs:{"d":"M63.15 59.98l-4.08-2.32-3.89 6.61 7.86 4.45L70.7 55.7l-7.55 4.28zM63.98 68.32l6.95-3.94-3.48-1.97-3.47 5.91zM55.07 63.27l3.47-5.9-3.47-1.97v7.87z"}}),_c('path',{staticClass:"cls-5",attrs:{"d":"M63.15 50.47l-7.78 4.41.04.02 7.74 4.38 7.78-4.4-7.78-4.41z"}}),_c('path',{staticClass:"cls-5",attrs:{"d":"M63.15 59.98l-4.08-2.32-3.89 6.61 7.86 4.45L70.7 55.7l-7.55 4.28zM63.98 68.32l6.95-3.94-3.48-1.97-3.47 5.91z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M39.39 26.69l-7.13 9.01H15l6.19-9.01h18.2z"}})])
          )
        }
      }
    